import styled, { css } from 'styled-components';
import { HELPER_CLASS } from './consts';
export const Placeholder = styled.div `
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-color: var(--bg-secondary);
`;
export const Handle = styled.div `
  color: var(--text-secondary);
  opacity: 0;

  cursor: pointer;

  &:hover {
    color: var(--text-primary);
  }
`;
export const DragHandle = styled(Handle) `
  position: absolute;
  left: -40px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: grab;
  color: var(--text-secondary);
`;
export const Item = styled.div `
  position: relative;

  &:hover ${DragHandle} {
    opacity: 1;
  }
`;
export const Element = styled.div(({ isDragged, disableSorting }) => css `
    display: flex;
    align-items: center;
    position: relative;
    padding: 8px 16px 8px 0;

    background: var(--bg-primary);
    cursor: ${disableSorting ? 'default' : 'grab'};

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: var(--border-secondary);
    }

    ${!isDragged &&
    css `
      &:hover ${Handle} {
        opacity: 1;
      }
    `}
    &.${HELPER_CLASS} {
      pointer-events: auto !important;
      z-index: 999;
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
      cursor: ${disableSorting ? 'default' : 'grabbing'};

      ${Handle} {
        cursor: ${disableSorting ? 'default' : 'grabbing'};
      }
    }
  `);
export const ImageContainer = styled.div `
  position: relative;
  margin-right: 16px;
  margin-left: 0;
`;
export const Name = styled.div `
  flex: 3;
  margin-right: 12px;

  a:hover {
    color: inherit;
    text-decoration: underline;
  }
`;
export const RightContent = styled.div `
  flex: 1;
  margin-right: 16px;
`;
